import { api } from './api';
import { getTenant} from '../helpers';
import { handleProgramMetadata } from './helpers';

export function getUserProgramsAPI(
  username: string,
  callback: (programs: any[]) => void,
  detailCallback?: (detail: any) => void
): void {
  const tenant = getTenant();

  const fetchPrograms = (tenantKey: string): Promise<any[]> => {
    return new Promise<any[]>((_resolve, _reject) => {
      const requestData = {
        username,
        platform_key: tenantKey,
        include_default_platform : 1
      };

      api.ibldmprograms.getUserPrograms(
        requestData,
        (response: any[]) => {
          if (!response || !Array.isArray(response)) {
            _resolve([]);
          } else {
            _resolve(response);
          }
        },
        (error) => {
          console.error('getUserCourses: ', error);
          _reject(error);
        }
      );
    });
  };

  fetchPrograms(tenant)
    .then((programs) => {
      callback(programs);
      if (detailCallback) {
        handleProgramMetadata(programs, detailCallback);
      }
    })
    .catch(() => callback([]));

}
